var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "md-layout md-alignment-center-space-between" },
    [
      _c(
        "div",
        { staticClass: "block_left" },
        [
          !_vm.isLoggedIn
            ? _c("div", { staticClass: "nav__logo" }, [_c("logotype")], 1)
            : _c(
                "md-menu",
                {
                  staticClass: "nav__notifications",
                  attrs: {
                    "md-active": _vm.isNotificationCardOpen,
                    "md-align-trigger": "",
                    "md-direction": "bottom-start"
                  },
                  on: {
                    "update:mdActive": function($event) {
                      _vm.isNotificationCardOpen = $event
                    },
                    "update:md-active": function($event) {
                      _vm.isNotificationCardOpen = $event
                    }
                  }
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "nav__notifications-btn",
                      attrs: { "md-menu-trigger": "", "md-ripple": false }
                    },
                    [
                      _c("md-icon", {
                        class: { "md-icon_active": _vm.isNotificationCardOpen },
                        attrs: { "md-src": "/static/img/bell.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "nav__notifications-label text_large" },
                        [
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.i18n.lbl_notifications()) + " "
                            )
                          ]),
                          _c(
                            "span",
                            { staticClass: "nav__notifications-counter" },
                            [
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    _vm.getUnreadMessages.length +
                                      _vm.getUnreadErrorInc.length +
                                      _vm.getUnreadErrorOut.length +
                                      _vm.getUnreadLymit.length +
                                      _vm.getUnreadInc.length +
                                      _vm.getUnreadOut.length
                                  ) +
                                  ")"
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-menu-content",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            this.getUnreadMessages.length > 0 ||
                            this.getUnreadErrorOut.length > 0 ||
                            this.getUnreadErrorInc.length > 0 ||
                            this.getUnreadLymit.length > 0 ||
                            this.getUnreadInc.length > 0 ||
                            this.getUnreadOut.length > 0,
                          expression:
                            "this.getUnreadMessages.length > 0 || this.getUnreadErrorOut.length > 0 || this.getUnreadErrorInc.length > 0 || this.getUnreadLymit.length > 0 || this.getUnreadInc.length > 0 || this.getUnreadOut.length > 0"
                        }
                      ],
                      staticClass: "nav__notifications-menu"
                    },
                    [
                      this.getUnreadMessages.length > 0
                        ? _vm._l(this.getUnreadMessages, function(msg) {
                            return _c(
                              "md-menu-item",
                              {
                                key: "unread_" + msg.message_key,
                                staticClass: "nav__notifications-item"
                              },
                              [
                                msg.message_key === "transaction_income"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_transaction_income(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : msg.message_key === "transaction_emission"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_transaction_emission(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : msg.message_key === "transaction_exchange"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_transaction_exchange(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : msg.message_key === "contract_money_lock"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_contract_money_lock(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : msg.message_key === "kyc_to_not_verified"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_kyc_to_not_verified(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : msg.message_key === "kyc_approve"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_kyc_approve(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : msg.message_key === "kyc_reject"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nav__notifications-content"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.i18n.notification_kyc_reject(
                                                msg.params
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.checkRead(msg.id)) +
                                    "\n          "
                                )
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.getUnreadInc.length > 0
                        ? [
                            _c(
                              "md-menu-item",
                              { staticClass: "notify_aml_title" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "nav__notifications-content" },
                                  [
                                    _vm._v(
                                      "> " +
                                        _vm._s(_vm.i18n.lbl_aml_notify_inc())
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(this.getUnreadInc, function(inc) {
                              return _c(
                                "md-menu-item",
                                {
                                  key: "aml_" + inc.id,
                                  staticClass:
                                    "nav__notifications-item notify_aml",
                                  attrs: { "data-notif-id": inc.notif_id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openDialog(inc.id, 2)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav__notifications-content"
                                    },
                                    [
                                      _vm._v("\n                   "),
                                      _c(
                                        "span",
                                        { staticClass: "notif-date" },
                                        [_vm._v(_vm._s(inc.timeStamp))]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.i18n.lbl_aml_title()) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      this.getUnreadOut.length > 0
                        ? [
                            _c(
                              "md-menu-item",
                              { staticClass: "notify_aml_title" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "nav__notifications-content" },
                                  [
                                    _vm._v(
                                      "> " +
                                        _vm._s(_vm.i18n.lbl_aml_notify_out())
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(this.getUnreadOut, function(out) {
                              return _c(
                                "md-menu-item",
                                {
                                  key: "inc_" + out.id,
                                  staticClass:
                                    "nav__notifications-item notify_aml",
                                  attrs: { "data-notif-id": out.notif_id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openDialog(out.id, 3)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav__notifications-content"
                                    },
                                    [
                                      _vm._v("   "),
                                      _c(
                                        "span",
                                        { staticClass: "notif-date" },
                                        [_vm._v(_vm._s(out.timeStamp))]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.i18n.lbl_aml_title())
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      this.getUnreadLymit.length > 0
                        ? [
                            _c(
                              "md-menu-item",
                              { staticClass: "notify_aml_title" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "nav__notifications-content" },
                                  [
                                    _vm._v(
                                      "> " + _vm._s(_vm.i18n.lbl_limit_title())
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(this.getUnreadLymit, function(lymit) {
                              return _c(
                                "md-menu-item",
                                {
                                  key: "lymit_" + lymit.id,
                                  staticClass:
                                    "nav__notifications-item notify_aml",
                                  attrs: { "data-notif-id": lymit.notif_id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openLymitDialog(lymit.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav__notifications-content"
                                    },
                                    [
                                      _vm._v("   "),
                                      _c(
                                        "span",
                                        { staticClass: "notif-date" },
                                        [_vm._v(_vm._s(lymit.timeStamp))]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.i18n.lbl_limit_s())
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      this.getUnreadErrorOut.length > 0
                        ? [
                            _c(
                              "md-menu-item",
                              { staticClass: "nnotify_aml_title" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "nav__notifications-content" },
                                  [
                                    _vm._v(
                                      "> " +
                                        _vm._s(_vm.i18n.lbl_aml_error_out())
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(this.getUnreadErrorOut, function(outerror) {
                              return _c(
                                "md-menu-item",
                                {
                                  key: "out_" + outerror.id,
                                  staticClass:
                                    "nav__notifications-item notify_aml",
                                  attrs: { "data-notif-id": outerror.notif_id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openDialog(outerror.id, -2)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav__notifications-content"
                                    },
                                    [
                                      _vm._v("   "),
                                      _c(
                                        "span",
                                        { staticClass: "notif-date" },
                                        [_vm._v(_vm._s(outerror.timeStamp))]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.i18n.lbl_aml_title())
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      this.getUnreadErrorInc.length > 0
                        ? [
                            _c(
                              "md-menu-item",
                              { staticClass: "notify_aml_title" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "nav__notifications-content" },
                                  [
                                    _vm._v(
                                      "> " +
                                        _vm._s(_vm.i18n.lbl_aml_error_inc())
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(this.getUnreadErrorInc, function(incerror) {
                              return _c(
                                "md-menu-item",
                                {
                                  key: "out_" + incerror.id,
                                  staticClass:
                                    "nav__notifications-item notify_aml",
                                  attrs: { "data-notif-id": incerror.notif_id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openDialog(incerror.id, -1)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav__notifications-content"
                                    },
                                    [
                                      _vm._v("   "),
                                      _c(
                                        "span",
                                        { staticClass: "notif-date" },
                                        [_vm._v(_vm._s(incerror.timeStamp))]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.i18n.lbl_aml_title())
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "md-menu-content",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            this.getUnreadMessages.length === 0 &&
                            this.getUnreadInc.length === 0 &&
                            this.getUnreadLymit.length === 0 &&
                            this.getUnreadOut.length === 0 &&
                            this.getUnreadErrorInc.length === 0 &&
                            this.getUnreadErrorOut.length === 0,
                          expression:
                            "this.getUnreadMessages.length === 0 && this.getUnreadInc.length === 0 && this.getUnreadLymit.length === 0 && this.getUnreadOut.length === 0 && this.getUnreadErrorInc.length === 0 && this.getUnreadErrorOut.length === 0"
                        }
                      ]
                    },
                    [
                      _c("md-menu-item", [
                        _c(
                          "div",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.i18n.notification_no_new_notifications()
                              )
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.notificationMenuRefreshed()) +
                      "\n    "
                  )
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "block_center" }, [
        _c(
          "div",
          {
            staticClass: "nav__langs",
            class: { "nav__langs-login": !_vm.isLoggedIn }
          },
          [
            _c("md-icon", { attrs: { "md-src": "/static/img/globe.svg" } }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "lang",
                class: _vm.getUserLocale === "ua" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.setLocale("ua")
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getUserLocale === "ru" || _vm.getUserLocale === "ua"
                        ? "УКР"
                        : "UA"
                    ) +
                    " "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "lang",
                class: _vm.getUserLocale === "en" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.setLocale("en")
                  }
                }
              },
              [_vm._v("EN")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "lang",
                class: _vm.getUserLocale === "ru" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.setLocale("ru")
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getUserLocale === "ru" || _vm.getUserLocale === "ua"
                        ? "РУС"
                        : "RU"
                    ) +
                    " "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block_right" },
        [
          !_vm.isLoggedIn
            ? _c(
                "div",
                { staticClass: "nav__auth" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "md-button simple-link simple-link-white",
                      attrs: {
                        tag: "button",
                        "md-ripple": false,
                        to: { name: "signup" }
                      }
                    },
                    [_vm._v(_vm._s(_vm.i18n.lbl_signup()))]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "md-button simple-link simple-link-white",
                      attrs: {
                        tag: "button",
                        "md-ripple": false,
                        to: { name: "login" }
                      }
                    },
                    [_vm._v(_vm._s(_vm.i18n.lbl_signin()))]
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.notificationMenuRefreshed()) +
                      "\n    "
                  )
                ],
                1
              )
            : _c(
                "md-menu",
                {
                  staticClass: "nav__user",
                  attrs: {
                    "md-active": _vm.isUserCardOpen,
                    "md-align-trigger": "",
                    "md-size": "huge",
                    "md-direction": "bottom-start"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setClipboard()
                    },
                    "update:mdActive": function($event) {
                      _vm.isUserCardOpen = $event
                    },
                    "update:md-active": function($event) {
                      _vm.isUserCardOpen = $event
                    }
                  }
                },
                [
                  _c(
                    "md-button",
                    { attrs: { "md-menu-trigger": "", "md-ripple": false } },
                    [
                      _c("md-icon", {
                        attrs: { "md-src": "/static/img/user-2.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "nav__user-label text_large" },
                        [_vm._v(_vm._s(_vm.userEmail))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-menu-content",
                    { staticClass: "nav__user-dropdown nav-dropdown" },
                    [
                      _c(
                        "md-menu-item",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              attrs: {
                                id: "clipboard-btn",
                                "data-clipboard-target": "#clipboard"
                              },
                              on: { click: _vm.showCopySuccess }
                            },
                            [
                              _c(
                                "md-icon",
                                {
                                  staticClass:
                                    "detail-row__clipboard-icon md-icon-size-065x"
                                },
                                [_vm._v("content_copy")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "nav-dropdown__info" }, [
                            _c("div", { staticClass: "nav-dropdown__email" }, [
                              _c("span", { attrs: { id: "clipboard" } }, [
                                _vm._v(_vm._s(_vm.userEmail))
                              ])
                            ]),
                            _vm._v(" "),
                            !_vm.accountBlocked
                              ? _c(
                                  "p",
                                  { staticClass: "nav-dropdown__status" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n.lbl_account() +
                                          " " +
                                          (_vm.accountState === "nil"
                                            ? _vm.i18n.lbl_not_verified()
                                            : _vm.i18n[_vm.accountState]())
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  { staticClass: "nav-dropdown__status" },
                                  [_vm._v(_vm._s(_vm.i18n.lbl_userBlocked()))]
                                )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-menu-item",
                        { staticClass: "nav-dropdown__actions" },
                        [
                          _c(
                            "div",
                            { staticClass: "btn-wrap space-between" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "btn btn_narrow md-primary md-yellow",
                                  on: { click: _vm.goSettings }
                                },
                                [_vm._v(_vm._s(_vm.i18n.lbl_settings()))]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "btn btn_narrow md-primary",
                                  attrs: { id: "btnSignout" },
                                  on: { click: _vm.signOut }
                                },
                                [_vm._v(_vm._s(_vm.i18n.lbl_signout()))]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _vm.activeDialog
        ? _c("AmlDialog", {
            attrs: {
              active: _vm.activeDialog,
              values: _vm.activeDialogData,
              account: _vm.accountId
            },
            on: { close: _vm.closeDialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeLymitDialog
        ? _c("LymitDialog", {
            attrs: {
              active: _vm.activeLymitDialog,
              values: _vm.activeLymitDialogData,
              account: _vm.accountId
            },
            on: { close: _vm.closeLymitDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd97f58e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd97f58e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/Navbar.vue
// module id = XBXX
// module chunks = 1